var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height pa-0 white", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "px-5", attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "div",
                { staticClass: "px-8 py-md-4 white login-form" },
                [
                  _c("v-img", {
                    staticClass: "ma-20",
                    attrs: {
                      contain: "",
                      src: require("@/assets/daycohost-tecnologicagente.svg"),
                      alt: "Logo Daycohost",
                      height: "150"
                    }
                  }),
                  _c(
                    "h3",
                    {
                      staticClass:
                        "mt-4 font-weight-light display-1 text-center"
                    },
                    [_vm._v("¡Bienvenido!")]
                  )
                ],
                1
              ),
              _c(
                "v-window",
                {
                  model: {
                    value: _vm.windowIndex,
                    callback: function($$v) {
                      _vm.windowIndex = $$v
                    },
                    expression: "windowIndex"
                  }
                },
                [
                  _c(
                    "v-window-item",
                    { attrs: { value: 1 } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "px-8 py-4 white login-form mx-auto",
                          attrs: {
                            flat: "",
                            color: "transparent",
                            "max-width": "400"
                          }
                        },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form1",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                }
                              },
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Usuario o correo electrónico",
                                  "prepend-inner-icon": "mdi-account",
                                  autocomplete: "on",
                                  rules: [_vm.rules.required]
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.validate($event)
                                  },
                                  change: _vm.clearClient
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              }),
                              _vm.customerOptions.length
                                ? _c("v-autocomplete", {
                                    staticClass: "transition-ease-in-out",
                                    attrs: {
                                      items: _vm.customerOptions,
                                      "auto-select-first": "",
                                      "item-value": "id",
                                      "prepend-inner-icon":
                                        "mdi-office-building",
                                      "item-text": "name",
                                      label: "Empresa"
                                    },
                                    model: {
                                      value: _vm.clientId,
                                      callback: function($$v) {
                                        _vm.clientId = $$v
                                      },
                                      expression: "clientId"
                                    }
                                  })
                                : _vm._e(),
                              _c("v-text-field", {
                                attrs: {
                                  autocomplete: "on",
                                  "append-icon": _vm.show
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.show ? "text" : "password",
                                  label: "Contraseña",
                                  "prepend-inner-icon": "mdi-lock",
                                  rules: [_vm.rules.required]
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.show = !_vm.show
                                  },
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.validate($event)
                                  }
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-5",
                              attrs: {
                                block: "",
                                dark: "",
                                color: "blue",
                                large: "",
                                loading: _vm.loadingForm,
                                autocomplete: "false"
                              },
                              on: { click: _vm.validate }
                            },
                            [_vm._v("Entrar")]
                          ),
                          _c(
                            "h2",
                            {
                              class: !_vm.loadingForm
                                ? "mt-4 font-weight-light  text-center cursor"
                                : "mt-4 font-weight-light  text-center",
                              staticStyle: { "font-size": "100%" },
                              on: {
                                click: function($event) {
                                  return _vm.changeWindow(3)
                                }
                              }
                            },
                            [_vm._v(" ¿Olvidaste tu contraseña? ")]
                          ),
                          _c(
                            "h2",
                            {
                              staticClass:
                                "mt-8 font-weight-bold text-center green--text",
                              staticStyle: { "font-size": "100%" }
                            },
                            [
                              _c("span", { staticClass: "blue--text" }, [
                                _vm._v("¿Dudas?")
                              ]),
                              _vm._v(" Consulta los tutoriales de uso "),
                              _c(
                                "a",
                                {
                                  staticClass: "green--text font-weight-light",
                                  staticStyle: {
                                    "text-decoration": "underline"
                                  },
                                  attrs: {
                                    href:
                                      "https://daycohost.com/tutoriales-portal-del-cliente",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("aquí")]
                              ),
                              _c("br"),
                              _vm._v(" 0800DAYCO24 ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-window-item",
                    { staticClass: "px-8", attrs: { value: 3 } },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "mb-8 font-weight-light headline text-center"
                        },
                        [_vm._v(" Recuperación de Contraseña ")]
                      ),
                      _c(
                        "h2",
                        {
                          staticClass:
                            "mt-8 mb-8 font-weight-light headline text-center",
                          staticStyle: { "font-size": "90% !important" }
                        },
                        [
                          _vm._v(
                            " Se le enviará los pasos a seguir para restablecer su contraseña al siguiente correo: "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Usuario o correo electrónico",
                              "prepend-inner-icon": "mdi-account",
                              autocomplete: "on",
                              rules: [_vm.rules.required]
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.sendEmail($event)
                              },
                              change: _vm.clearClient
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.customerOptions.length
                        ? _c(
                            "h2",
                            {
                              staticClass:
                                "mb-2 font-weight-light headline text-center",
                              staticStyle: { "font-size": "90% !important" }
                            },
                            [
                              _vm._v(
                                " Por favor, selecciona la empresa asociada "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.customerOptions.length
                        ? _c("v-autocomplete", {
                            attrs: {
                              items: _vm.customerOptions,
                              "auto-select-first": "",
                              "item-value": "id",
                              "item-text": "name",
                              label: "Empresa",
                              "prepend-inner-icon": "mdi-office-building"
                            },
                            model: {
                              value: _vm.clientId,
                              callback: function($$v) {
                                _vm.clientId = $$v
                              },
                              expression: "clientId"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-5",
                          attrs: {
                            block: "",
                            dark: "",
                            color: "rgba(25,58,81,1)",
                            large: "",
                            loading: _vm.loadingSendEmailButton,
                            autocomplete: "false"
                          },
                          on: { click: _vm.sendEmail }
                        },
                        [_vm._v("Enviar Correo")]
                      ),
                      _c(
                        "h2",
                        {
                          class: !_vm.loadingForm
                            ? "mt-4 font-weight-light  text-center cursor"
                            : "mt-4 font-weight-light  text-center",
                          staticStyle: { "font-size": "100%" },
                          on: {
                            click: function($event) {
                              return _vm.changeWindow(1)
                            }
                          }
                        },
                        [
                          _c("strong", { staticClass: "mx-auto" }, [
                            _vm._v(" Volver ")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "bg-img d-none d-sm-flex align-end white--text",
              attrs: { cols: "8" }
            },
            [
              _c(
                "div",
                { staticClass: "ma-12 px-10 font-weight-light spotlight-text" },
                [
                  _c("h1", { staticClass: "display-3" }, [
                    _vm._v(" La "),
                    _c("strong", { staticClass: "font-weight-bold" }, [
                      _vm._v("Nube")
                    ]),
                    _vm._v(" de servicios"),
                    _c("br"),
                    _vm._v("más cerca de ti. ")
                  ])
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: _vm.snackbarColor },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: { click: _vm.closeSnackbar }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }